import React, { lazy } from 'react';
import { createBrowserRouter } from 'react-router';

import Loadable from '../layouts/full/shared/loadable/Loadable';

import AuthGuard from 'src/guards/authGuard/AuthGuard';
import GuestGuard from 'src/guards/authGuard/GuestGaurd';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
const DashboardPage = Loadable(lazy(() => import('../views/pages/dashboard/Dashboard.js')));

const EditAccountPage = Loadable(lazy(() => import('../views/pages/account-setting/AccountSetting.js')));
const ChangePasswordPage = Loadable(lazy(() => import('../views/pages/change-password/ChangePassword.js')));

const ViewClassPage = Loadable(lazy(() => import('../views/pages/classes/ViewClass.js')));
const ClassListPage = Loadable(lazy(() => import('../views/pages/classes/ClassListPage.js')));

const StudyPacks = Loadable(lazy(() => import('../views/pages/study-packs/StudyPacks.js')));
const ViewStudyPack = Loadable(lazy(() => import('../views/pages/study-packs/ViewStudyPack.js')));

const BuyClassPage = Loadable(lazy(() => import('../views/pages/payments/BuyClass.js')));
const BuyClassCheckout = Loadable(lazy(() => import('../views/pages/payments/BuyClassCheckout.js')));
const BuyStudyPackCheckout = Loadable(lazy(() => import('../views/pages/payments/BuyStudyPackCheckout.js')));
const PaymentList = Loadable(lazy(() => import('../views/pages/payments/PaymentList.js')));
const SPPaymentList = Loadable(lazy(() => import('../views/pages/payments/SPPaymentList.js')));
const PaymentStatus = Loadable(lazy(() => import('../views/pages/payments/PaymentStatus.js')));
const Deliveries = Loadable(lazy(() => import('../views/pages/tute-delivery/Deliveries.js')));

// authentication
const Login = Loadable(lazy(() => import('../views/authentication/auth/Login')));
const Register = Loadable(lazy(() => import('../views/authentication/auth/Register')));
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/auth/ForgotPassword')));
const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Maintenance = Loadable(lazy(() => import('../views/authentication/Maintenance')));

const Router = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <FullLayout />
      </AuthGuard>
    ),
    children: [
      { path: '/', element: <DashboardPage /> },

      { path: '/classes', element: <ClassListPage /> },
      { path: '/view-class/:id', element: <ViewClassPage /> },

      { path: '/study-packs', exact: true, element: <StudyPacks /> },
      { path: '/view-study-pack/:id', exact: true, element: <ViewStudyPack /> },

      { path: '/edit-account', exact: true, element: <EditAccountPage /> },
      { path: '/change-password', exact: true, element: <ChangePasswordPage /> },

      { path: '/buy-class', exact: true, element: <BuyClassPage /> },
      { path: '/buy-class/:id', exact: true, element: <BuyClassCheckout /> },
      { path: '/buy-study-pack/:id', exact: true, element: <BuyStudyPackCheckout /> },
      { path: '/payments', exact: true, element: <PaymentList /> },
      { path: '/study-pack-payments', exact: true, element: <SPPaymentList /> },
      { path: '/payments/:id', exact: true, element: <PaymentStatus /> },
      { path: '/tute-delivery', exact: true, element: <Deliveries /> },

      { path: '*', element: <Error /> },
    ],
  },
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '/auth/maintenance', element: <Maintenance /> },
      { path: '*', element: <Error /> },
    ],
  },
  {
    path: '/',
    element: (
    <GuestGuard>
      <BlankLayout />
    </GuestGuard>
    ),
    children: [
      { path: '/auth/404', element: <Error /> },
      { path: '/auth/maintenance', element: <Maintenance /> },
      { path: '/auth/login', element: <Login /> },
      { path: '/auth/register', element: <Register /> },
      { path: '/auth/forgot-password', element: <ForgotPassword /> },
      { path: '*', element: <Error /> },
    ],
  }
];

const router = createBrowserRouter(Router);

export default router;
